import { useMemo } from "react";
import { useInView } from "../../hooks/useInView";
import { useHomePage } from "../../context/HomePageContext";
import { resolveClients } from "../../lib/homePageContent";
import "../../style/animations.css";
import { useLanguage } from "../../context/LanguageContext";

/**
 * Logo client. Dikelola dari admin (Home Page -> Our Client). Belum ada logo
 * bawaan, jadi section ini baru tampil setelah admin menambahkan client.
 */
export default function OurClientSection() {
  const { data } = useHomePage();
  const { language } = useLanguage();
  const clients = useMemo(
    () => resolveClients(data?.clients, language),
    [data, language],
  );
  const { ref, inView } = useInView<HTMLDivElement>();

  if (clients.items.length === 0) return null;

  return (
    <section
      className="
        w-full

        lg:py-16
      ">
      <div ref={ref} className="w-full mx-auto">
        {/* TITLE */}
        <div
          className={`
            flex
            justify-center

            mb-16

            reveal-up
            ${inView ? "is-visible" : ""}
          `}>
          <h2
            className="
              text-[#324A5A]
              text-center

              text-[40px]
              font-bold

              lg:text-[56px]
            ">
            {clients.title}
          </h2>
        </div>

        {/* LOGO BOX */}
        <div
          className="
            w-full

            bg-white

            px-8
            py-12

            lg:px-16
            lg:py-14
          ">
          <div
            className="
              flex
              flex-wrap

              gap-x-10
              gap-y-10

              items-center
              justify-center
            ">
            {clients.items.map((client, index) => (
              <div
                key={client.key}
                style={{
                  transitionDelay: inView ? `${index * 80}ms` : "0ms",
                }}
                className={`
                  reveal-scale
                  ${inView ? "is-visible" : ""}

                  flex
                  h-[72px]
                  w-[140px]
                  lg:w-[160px]
                  items-center
                  justify-center
                `}>
                <img
                  src={client.logo}
                  alt={client.name}
                  className="
                    max-h-[64px]
                    max-w-[160px]

                    object-contain
                  "
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
